import fetch from '@/helpers/fetch'
import dateHelper from '@/helpers/date'

export default {
	state: {
		emailsGroupedByDate: null,
		emailsAll: null,

		elaborators: {},
		sales: {},
		reviewers: {},
	},
	mutations: {
		SET_LIST(state, emails) {
			state.emailsAll = emails
			processEmail(emails, state, null)
		},

		FILTER_LIST(state, filters) {
			processEmail(state.emailsAll, state, filters)
		},

		UPDATE_EMAIL(state, email) {
			const sendAt = getSendAtDayMonthYear(email.send_at)
			const list = state.emailsGroupedByDate[sendAt]
			let index

			if (list) {
				list.find((e, i) => {
					const condition = e.id === email.id

					if (condition) {
						index = i
					}

					return condition
				})

				if (index || index === 0) {
					list.splice(index, 1, email)
				}
			}
		},
	},
	actions: {
		fetchEmailLogsAdm: async function (
			context,
			options,
		): Promise<object[]> {
			const seeAll = options.seeAll
			const date = options.date

			let url = '/api/email_logs?is_adm=true' // Sempre inclui is_adm=true
			if (!seeAll) {
				url += '&not_sent'
			} else {
				url += `&date=${date}`
			}

			const data = await fetch.get(url)

			context.commit('SET_LIST', data)

			return data
		},
		fetchSaveEmailLogsAdm: async function (context, email) {
			email.is_adm = true

			const data = await fetch.put('/api/email_logs', email)

			if (data.ok) {
				// if (email.send_at) {
				// 	context.dispatch('fetchEmailLogsAdm')
				// } else {
				// 	context.commit('UPDATE_EMAIL', data.email)
				// }
			} else {
				console.error(data)
			}

			return data
		},
		fetchSendReports: async function (context, token): Promise<object[]> {
			const url = `/api/report/${token}`
			const data = await fetch.post(url, {})
			return data
		},
		fetchReportToday: async function (context, token): Promise<object[]> {
			const url = '/api/report_today'
			const data = await fetch.get(url)
			return data
		},
		fetchSendEmailNow: async function (
			context,
			emailLog,
		): Promise<object[]> {
			const url = '/api/email_logs/send'
			const data = await fetch.post(url, { id: emailLog.id })
			return data
		},
		filterEmails: function (context, filters) {
			context.commit('FILTER_LIST', filters)
		},
	},
}

function getSendAtDayMonthYear(sendAt) {
	const dateSp = dateHelper.sao_paulo.convertTimezoneToSp(sendAt)
	const result = dateSp?.split('T')?.[0]
	return result
}

function processEmail(emailsOrderedByDate, state, filters) {
	const filterArray: any[] = []
	if (filters?.elaborator) {
		filterArray.push({
			elaboratorEmail: filters?.elaborator,
		})
	}

	if (filters?.sales) {
		filterArray.push({
			salesEmail: filters?.sales,
		})
	}

	if (filters?.reviewer) {
		filterArray.push({
			reviewerEmail: filters?.reviewer,
		})
	}

	const emailsGroupedByDate = {}

	if (emailsOrderedByDate && emailsOrderedByDate?.length) {
		emailsOrderedByDate.forEach((email) => {
			const sendAt = getSendAtDayMonthYear(email.send_at)

			let filtered = true

			for (const filter of filterArray) {
				if (
					filter?.elaboratorEmail &&
					filter?.elaboratorEmail !== email?.group?.elaborator?.email
				) {
					filtered = false
					break
				}

				if (
					filter?.salesEmail &&
					filter?.salesEmail !==
						email?.group?.reportSendingFrom?.email
				) {
					filtered = false
					break
				}

				if (
					filter?.reviewerEmail &&
					filter?.reviewerEmail !== email?.group?.reviewer?.email
				) {
					filtered = false
					break
				}
			}

			if (filtered) {
				emailsGroupedByDate[sendAt] = emailsGroupedByDate[sendAt] ?? []
				emailsGroupedByDate[sendAt].push(email)
			}

			const elaboratorEmail = email?.group?.elaborator?.email
			state.elaborators[elaboratorEmail] =
				state?.elaborators?.[elaboratorEmail] || []
			state.elaborators[elaboratorEmail].push(email)

			const userEmail = email?.group?.reportSendingFrom?.email
			if (userEmail) {
				state.sales[userEmail] = state?.sales?.[userEmail] || []
				state.sales[userEmail].push(email)
			}

			const reviewerEmail = email?.group?.reviewer?.email
			state.reviewers[reviewerEmail] =
				state?.reviewers?.[reviewerEmail] || []
			state.reviewers[reviewerEmail].push(email)
		})
	}

	state.emailsGroupedByDate = emailsGroupedByDate
}
